import React from 'react';
import { Link } from 'gatsby';
import { motion, AnimateSharedLayout, AnimatePresence } from 'framer-motion';
import cx from 'classnames';

import { usePortalQuery } from '@querys/usePortalQuery';
import { SubscribeModal } from '../nav/subscribeModal';

export const CTA = () => {
  const [activeButton, setActiveButton] = React.useState(0);

  const { contactPortal } = usePortalQuery();

  const [open, setOpen] = React.useState(false);
  const buttons = [
    {
      heading: 'Subscribe',
      subheading: 'Monthly CMNZ Newsletter',
      popup: true,
    },
    {
      heading: 'Need help?',
      subheading: 'Get in touch now',
      link: contactPortal?.slug?.current,
    },
  ];

  return (
    <>
      <AnimateSharedLayout>
        <div className='bg-white bg-opacity-20 w-full rounded-full flex'>
          {buttons?.map(({ heading, subheading, popup, link }, i) => {
            const active = activeButton === i;
            return (
              <div
                key={i}
                onMouseEnter={() => setActiveButton(i)}
                className='w-full relative py-9 pl-14 pr-9 font-bold'>
                <div className='flex items-center justify-between relative z-10'>
                  <div
                    className={cx('transition-standard', {
                      'text-teal': active,
                      'text-white': !active,
                    })}>
                    <h4 className='blockH5'>{heading}</h4>
                    <span className='blockH7'>{subheading}</span>
                  </div>
                  {popup ? (
                    <button
                      onClick={() => setOpen(true)}
                      className={cx(
                        'transition-standard rounded-full h-[90px] w-[90px] bg-opacity-15 flex items-center justify-center cursor-pointer nav-hover hover:bg-opacity-100',
                        {
                          'bg-teal': active,
                          'bg-white': !active,
                        },
                      )}>
                      <svg
                        width='39'
                        height='17'
                        viewBox='0 0 39 17'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className='transition-standard'>
                        <path
                          d='M38.3216 8.9882C38.7447 8.56513 38.7447 7.8792 38.3216 7.45614L31.4273 0.561845C31.0042 0.138777 30.3183 0.138777 29.8952 0.561845C29.4722 0.984913 29.4722 1.67084 29.8952 2.09391L36.0235 8.22217L29.8952 14.3504C29.4722 14.7735 29.4722 15.4594 29.8952 15.8825C30.3183 16.3056 31.0042 16.3056 31.4273 15.8825L38.3216 8.9882ZM0 9.3055H37.5556V7.13883H0V9.3055Z'
                          fill={active ? '#036483' : 'white'}
                        />
                      </svg>
                    </button>
                  ) : (
                    <Link
                      to={`/${link}`}
                      className={cx(
                        'transition-standard rounded-full h-[90px] w-[90px] bg-opacity-15 flex items-center justify-center cursor-pointer nav-hover hover:bg-opacity-100',
                        {
                          'bg-teal': active,
                          'bg-white': !active,
                        },
                      )}>
                      <svg
                        width='39'
                        height='17'
                        viewBox='0 0 39 17'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className='transition-standard'>
                        <path
                          d='M38.3216 8.9882C38.7447 8.56513 38.7447 7.8792 38.3216 7.45614L31.4273 0.561845C31.0042 0.138777 30.3183 0.138777 29.8952 0.561845C29.4722 0.984913 29.4722 1.67084 29.8952 2.09391L36.0235 8.22217L29.8952 14.3504C29.4722 14.7735 29.4722 15.4594 29.8952 15.8825C30.3183 16.3056 31.0042 16.3056 31.4273 15.8825L38.3216 8.9882ZM0 9.3055H37.5556V7.13883H0V9.3055Z'
                          fill={active ? '#036483' : 'white'}
                        />
                      </svg>
                    </Link>
                  )}
                </div>
                {active && (
                  <motion.div
                    layoutId='button'
                    className='w-full h-full bg-white absolute top-0 left-0 rounded-full'
                  />
                )}
              </div>
            );
          })}
        </div>
      </AnimateSharedLayout>

      {/* Subscribe Popup */}
      <AnimatePresence exitBeforeEnter>
        {open && <SubscribeModal open={open} setOpen={setOpen} />}
      </AnimatePresence>
    </>
  );
};

export const CTAmobile = () => {
  const { contactPortal } = usePortalQuery();

  const [open, setOpen] = React.useState(false);
  const buttons = [
    {
      heading: 'Subscribe',
      subheading: 'Monthly CMNZ Newsletter',
      popup: true,
    },
    {
      heading: 'Need help?',
      subheading: 'Get in touch now',
      link: contactPortal?.slug?.current,
    },
  ];

  return (
    <>
      <div className='flex flex-col gap-y-4'>
        {buttons.map(({ heading, subheading, popup, link }, i) => (
          <div
            key={i}
            onClick={() => setOpen(true)}
            className='bg-white w-full rounded-full flex'>
            <div className='w-full relative py-4 pl-8 pr-5 font-bold'>
              <div className='flex items-center justify-between relative z-10'>
                <div className='transition-standard text-teal'>
                  <h4 className='blockH5'>{heading}</h4>
                  <span className='blockH7'>{subheading}</span>
                </div>
                {popup ? (
                  <button className='transition-standard rounded-full w-[52px] h-[52px] bg-opacity-15 flex items-center justify-center cursor-pointer bg-teal'>
                    <svg
                      width='39'
                      height='17'
                      viewBox='0 0 39 17'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      className='transition-standard w-6'>
                      <path
                        d='M38.3216 8.9882C38.7447 8.56513 38.7447 7.8792 38.3216 7.45614L31.4273 0.561845C31.0042 0.138777 30.3183 0.138777 29.8952 0.561845C29.4722 0.984913 29.4722 1.67084 29.8952 2.09391L36.0235 8.22217L29.8952 14.3504C29.4722 14.7735 29.4722 15.4594 29.8952 15.8825C30.3183 16.3056 31.0042 16.3056 31.4273 15.8825L38.3216 8.9882ZM0 9.3055H37.5556V7.13883H0V9.3055Z'
                        fill='#036483'
                      />
                    </svg>
                  </button>
                ) : (
                  <Link
                    to={`/${link}`}
                    className='transition-standard rounded-full w-[52px] h-[52px] bg-opacity-15 flex items-center justify-center cursor-pointer bg-teal'>
                    <svg
                      width='39'
                      height='17'
                      viewBox='0 0 39 17'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      className='transition-standard w-6'>
                      <path
                        d='M38.3216 8.9882C38.7447 8.56513 38.7447 7.8792 38.3216 7.45614L31.4273 0.561845C31.0042 0.138777 30.3183 0.138777 29.8952 0.561845C29.4722 0.984913 29.4722 1.67084 29.8952 2.09391L36.0235 8.22217L29.8952 14.3504C29.4722 14.7735 29.4722 15.4594 29.8952 15.8825C30.3183 16.3056 31.0042 16.3056 31.4273 15.8825L38.3216 8.9882ZM0 9.3055H37.5556V7.13883H0V9.3055Z'
                        fill='#036483'
                      />
                    </svg>
                  </Link>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Subscribe Popup */}
      <AnimatePresence exitBeforeEnter>
        {open && <SubscribeModal open={open} setOpen={setOpen} />}
      </AnimatePresence>
    </>
  );
};
